<template>

    <!-- UI -->
    <nav class="custom-nav blue-grey darken-3 hide-on-small-only"></nav>

    <nav class="nav-extended blue-grey darken-3 hide-on-small-only">
        <div class="nav-wrapper container">
            <a href="#!" class="brand-logo" @click.prevent="handleActive(home)">{{ home?.name }}</a>
            <ul class="right hide-on-med-and-down">
                <li v-for="tab in tabs" :key="tab.id" :class="{ 'active blue-grey darken-2': tab.id == currTab.id }">
                    <a href="#" @click.prevent="handleActive(tab)">{{ tab.title }}</a>
                </li>
            </ul>
        </div>
        <div class="nav-content container">
            <!-- Add Button -->
            <span class="hide-on-med-and-down" v-if="isReady">
                <a class="left btn-floating btn-large halfway-fab waves-effect waves-light red darken-2"
                    title="Add Encounter"
                    @click.prevent="handleActive(tabs?.find(x => x.title.toLowerCase() == 'home'))">
                    <i class="material-icons">cancel</i>
                </a>
            </span>
        </div>
    </nav>

    <!-- Mobile only -->
  <nav class="blue-grey darken-4 hide-on-large-only">
      <ul class="tabs tabs-transparent">
        <li v-for="tab in tabs" :key="tab.id" class="tab" :class="{ 'active': tab.id == currTab.id }">
          <a href="#" @click.prevent="handleActive(tab)">{{ tab?.title?.split(" ")[0] }}</a>
          <!-- <a href="#" @click.prevent="handleActive(tab)" v-else>{{ tab.title }}</a> -->
        </li>
      </ul>
  </nav>

    <!-- search layer -->
    <!-- <div class="grey lighten-4">
        <div class="container section"></div>
    </div> -->

  <!-- breadcrumbs -->
    <nav class="grey lighten-4 z-depth-0">
      <div class="container nav-wrapper">
        <div class="col s12">
          <router-link to="/" class="breadcrumb teal-text"><small> <i class="material-icons left">home</i> Dashboard</small></router-link>
          <router-link to="/care/encounter" class="breadcrumb blue-grey-text text-darken-3"><small> Encounter Home</small></router-link>
          <span class="breadcrumb blue-grey-text pointable"><small>Request</small></span>
        </div>
      </div>
    </nav>

    <div class="container">
        <!-- <br /> -->

        <LoadingDiv v-if="!isReady" />

        <template v-else>
            <br />
            <!-- <EnrolleeAuth @restart="handleRestart" :enrollee="enrollee" :serverDate="serverDate" v-if="enrollee" />
      <StartAuth @next="handleNext" v-else /> -->
            <EnrolleeEncounter @restart="handleRestart" @refresh="handleRefresh" :serverDate="serverDate"
                :searchPeriod="searchPeriod" :enrollee="enrollee" v-if="enrollee" />
            <StartEncounter @next="handleNext" :serverTime="serverTime" v-else />
        </template>
    </div>
</template>


<script>
import { ref, onMounted } from "vue";
import { useRouter } from "vue-router";
import { useStore } from "vuex";
import getItems from "@/composables/getItems";
import LoadingDiv from "@/components/LoadingDiv.vue";
import StartEncounter from "@/components/encounter/StartEncounterComponent.vue";
import EnrolleeEncounter from "@/components/encounter/EnrolleeEncounterComponent.vue";
import { getCachedServerDate } from "@/composables/requestOptimization";


export default {
    name: "authAdd",
    props: ["encounterId"],
    components: { LoadingDiv, StartEncounter, EnrolleeEncounter },
    setup(props) {
        const isReady = ref(false);
        const enrollee = ref(null);
        const serverDate = ref(null);
        const serverTime = ref(null);
        const searchPeriod = ref(null);
        const home = ref(null);
        const currTab = ref(null);
        const tabs = ref([]);

        // vue router
        const router = useRouter();

        // store
        const store = useStore();

        // config
        const providerId = store.state?.user?.account?.id;

        // start
        onMounted(() => {
            // page name
            document.title = "Request Authourization | EasyHMO";
        });

        // menu
        onMounted(() => {
            // load tab
            tabs.value.push({ id: 1, name: "Encounters", title: "Home", icon: "arrow_back", url: "encounter", hash: null, });
            tabs.value.push({ id: 2, name: "Encounters", title: "Request", icon: null, url: "encounterAdd", hash: null, });

            // set default
            currTab.value = tabs.value.find(x => x.title.includes("Request"));
            // set home
            home.value = tabs.value.find(x => x.title.includes("Home"));
        });

        // get current id
        onMounted(() => {
             // check it's new encounter
            if (!props.encounterId) return;
            // load enrollee
            (async () => {
                const { res } = await getItems(`encounter/single/select/${providerId}/${props.encounterId}`);

                if (res.value) {
                    enrollee.value = res.value.data;
                } else {
                    // encounter didnt load properly
                    router.push({ name: "encounter" });
                }
                // now ready
                isReady.value = true;
            })();
        });

        // set
        onMounted(() => {
            // check it's new encounter
            if (props.encounterId) return;
            // load server date
            (async () => {
                const { res } = await getCachedServerDate(getItems);

                if (res.value) {
                    serverTime.value = res.value.data;
                }

                // now ready
                isReady.value = true;
            })();
        });

        // handle curr status
        const handleActive = (tab) => {
            // refer
            if (tab.hash) {
                router.push({ name: tab.url, hash: tab.hash });
            } else {
                router.push({ name: tab.url });
            }
        };

        // handle refresh
        const handleRefresh = (val) => {
            enrollee.value = val;
        }

        // handle next
        const handleNext = (val) => {
            enrollee.value = val.value;
            searchPeriod.value = val.searchPeriod;
            serverDate.value = val.serverDate;
        };

        // handle restart
        const handleRestart = () => {
            router.push({ name: home.value.url });
        };
        // const handleRestart = () => {
        //     enrollee.value = null;
        //     serverDate.value = null;
        // };


        return {
            handleActive,
            home,
            serverDate,
            serverTime,
            searchPeriod,
            currTab,
            tabs,
            handleRefresh,
            handleNext,
            handleRestart,
            isReady,
            enrollee,
        };
    },
};
</script>

<style scoped>
.custom-nav {
    height: 15px;
}

/* .nav-extended .nav-wrapper {
  padding: 0 20px;
} */

.brand-logo {
    font-weight: 300;
    font-size: 1.5rem;
}

.nav-wrapper ul li a {
    font-weight: 400;
    padding: 0 15px;
}

.nav-content {
    min-height: 20px;
}
</style>
